const wordsList = [
  "APPLE", "BANK", "BEACH", "BIRD", "BOOK", "BOX", "BRIDGE", "BUTTON",
  "CAR", "CARD", "CARROT", "CHEESE", "CHOCOLATE", "CITY", "CLOUD", "COFFEE",
  "COMPUTER", "CROWN", "DESERT", "DIAMOND", "DOCTOR", "DOG", "DOOR", "DRAGON",
  "DREAM", "EAGLE", "EARTH", "EGG", "ELEPHANT", "EYE", "FAN", "FIELD",
  "FIRE", "FISH", "FLOWER", "FOREST", "FORK", "FRANCE", "FRUIT", "GARDEN",
  "GHOST", "GLASS", "GLOVE", "GOLD", "GRASS", "GUITAR", "HAIR", "HAND",
  "HEART", "HELICOPTER", "HORSE", "HOSPITAL", "HOTEL", "HOUSE", "ICE", "ICE CREAM",
  "ISLAND", "JAIL", "JAM", "JET", "JUPITER", "KEY", "KING", "KITCHEN",
  "KITE", "KNIFE", "LASER", "LAWYER", "LEAF", "LIBRARY", "LIGHT", "LIGHTNING",
  "LION", "LOCK", "LOG", "LONDON", "MAIL", "MAP", "MARKET", "MATH",
  "MERCURY", "MEXICO", "MICROSCOPE", "MILK", "MILLIONAIRE", "MIRROR", "MOON", "MOUNTAIN",
  "MOUSE", "MOUTH", "MOVIE", "MUSEUM", "MUSIC", "NAIL", "NAPKIN", "NEEDLE",
  "NEST", "NIGHT", "NINJA", "NOSE", "NURSE", "OCEAN", "OIL", "ORANGE",
  "OXYGEN", "PAINT", "PALM", "PAPER", "PARK", "PARTY", "PENGUIN", "PIANO",
  "PILLOW", "PILOT", "PIN", "PIPE", "PIRATE", "PIZZA", "PLANET", "PLASTIC",
  "PLATE", "POISON", "POLICE", "POOL", "PRISON", "PYRAMID", "QUEEN", "RABBIT",
  "RAINBOW", "RECORD", "RESTAURANT", "RING", "ROBOT", "ROCKET", "ROOF", "ROPE",
  "ROSE", "RUSSIA", "SATELLITE", "SCHOOL", "SCIENTIST", "SCORPION", "SCREEN", "SEA",
  "SEAL", "SHARK", "SHIP", "SHOE", "SHOP", "SHOWER", "SINK", "SKY",
  "SLEEP", "SNAKE", "SNOW", "SPACE", "SPIDER", "SPRING", "SPY", "SQUARE",
  "STAR", "STEAK", "STREAM", "STRIKE", "SUGAR", "SUMMER", "SUN", "SUPERHERO",
  "SWING", "TABLE", "TANK", "TELESCOPE", "TEMPLE", "THEATER", "THIEF", "THUMB",
  "TICKET", "TIE", "TIME", "TOKYO", "TOOTH", "TORCH", "TOWER", "TRAIN",
  "TRIANGLE", "TRIP", "TRUNK", "UMBRELLA", "UNICORN", "UNIVERSE", "VAMPIRE", "VAN",
  "WAKE", "WALL", "WAR", "WATCH", "WATER", "WATERFALL", "WAVE", "WAX",
  "WEB", "WEDDING", "WHALE", "WHEEL", "WHIP", "WIND", "WITCH", "WIZARD",
  "WOLF", "WORLD", "WORM", "YARD", "YOGA", "YOGURT", "ZEBRA", "ZOMBIE"
];

export default wordsList; 